import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, SwiperOptions } from 'swiper';
import 'swiper/swiper-bundle.css';
import { IconType } from '@react-icons/all-files/lib';
import classNames from 'classnames';
import { FiChevronLeft } from '@react-icons/all-files/fi/FiChevronLeft';
import { FiChevronRight } from '@react-icons/all-files/fi/FiChevronRight';

// SwiperCore.use registers a Swiper module; it is not a React hook.
// eslint-disable-next-line react-hooks/rules-of-hooks
SwiperCore.use([Navigation]);

interface CarouselProps {
  children: React.ReactNode;
  slidesPerView?: number;
  noBreakpoints?: boolean;
  arrowsAbsolute?: boolean;
  id: string | number;
}

function CarouselButton(props: {
  forward?: boolean;
  arrowsAbsolute: boolean;
  icon: IconType;
  id: string;
}) {
  const Icon = props.icon;
  return (
    <button
      type="button"
      className={classNames(
        'py-8 carousel-nav text-4xl text-blue-dark',
        props.arrowsAbsolute ? 'sm:absolute' : props.forward ? 'ml-2' : 'mr-2',
        props.forward ? '-right-10' : '-left-10',
      )}
      id={props.id}
      onClick={(e) => e.stopPropagation()}
    >
      <Icon />
    </button>
  );
}

export function Carousel({
  noBreakpoints = false,
  arrowsAbsolute = true,
  ...props
}: CarouselProps) {
  const nextButtonId = `next-${props.id}`;
  const prevButtonId = `prev-${props.id}`;
  const swiperSettings: SwiperOptions = {
    autoHeight: true,
    navigation: { nextEl: `#${nextButtonId}`, prevEl: `#${prevButtonId}` },
    slidesPerView: props.slidesPerView ? props.slidesPerView : undefined,
    spaceBetween: 15,
    breakpoints: !noBreakpoints
      ? {
          // when window width is >= 0px
          0: {
            slidesPerView: 1.05,
            spaceBetween: 10,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          1024: {
            slidesPerView: 3,
          },
        }
      : undefined,
  };
  return (
    <div
      className="relative flex items-center carousel"
      onClick={(e) => e.stopPropagation()}
    >
      <CarouselButton
        id={prevButtonId}
        icon={FiChevronLeft}
        arrowsAbsolute={arrowsAbsolute}
      />
      <Swiper className="px-2" {...swiperSettings}>
        {React.Children.map(props.children, (child) => (
          <SwiperSlide>{child}</SwiperSlide>
        ))}
      </Swiper>
      <CarouselButton
        id={nextButtonId}
        forward
        icon={FiChevronRight}
        arrowsAbsolute={arrowsAbsolute}
      />
    </div>
  );
}
